import { createContext, useContext } from "react";
import type { Persistor } from "redux-persist";

export const PersistorContext = createContext<Persistor | null>(null);

export const usePersistor = (): Persistor => {
  const persistor = useContext(PersistorContext);
  if (!persistor) {
    throw new Error(
      "usePersistor must be used within a PersistorContext.Provider"
    );
  }
  return persistor;
};
